var v1="<div class=\"form-group\"> <label for=\"{{ vm.settings.dataAt }}\">{{ vm.settings.displayName }}</label> <div> <ui-select ng-model=\"vm.data\"> <ui-select-match allow-clear=\"true\" class=\"ui-select-match\"> {{ $select.selected.Code }} </ui-select-match> <ui-select-choices repeat=\"item.Code as item in vm.policies\" refresh=\"vm.refreshPolicies($select.search)\" refresh-delay=\"300\"> <div>{{ item.Code }} ({{ item.Title }})</div> </ui-select-choices> </ui-select> </div> <p class=\"help-block\" ng-if=\"vm.settings.helpText\">{{ vm.settings.helpText }}</p> </div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/lbaPolicyCodeSelect/lbaPolicyCodeSelect.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbaPolicyCodeSelect/lbaPolicyCodeSelect.html
// module id = 406
// module chunks = 0